/*
 * @Date: 2024-06-14 16:21:42
 * @LastEditTime: 2024-06-17 17:29:38
 */
import { BASE_URL } from "@/services/api";
import { request, METHOD } from "@/utils/request";

export async function UploadImage(params) {
  return request(`${BASE_URL}/ai/uploadImage`, METHOD.POST, params, {
    headers: {"Content-Type": "multipart/form-data",},
  });
}
export async function showAIMonitorStatus(params) {
  return request(`${BASE_URL}/ai/showAIMonitorStatus`, METHOD.POST, params);
}
export async function verifyPatientMonitor(params) {
  return request(`${BASE_URL}/ai/verifyPatientMonitor`, METHOD.POST, params);
}
export async function lockPatientMonitor(params) {
  return request(`${BASE_URL}/ai/lockPatientMonitor`, METHOD.POST, params);
}
export async function releasePatientMonitor(params) {
  return request(`${BASE_URL}/ai/releasePatientMonitor`, METHOD.POST, params);
}
